/**
 * TXM-479 — classificação (Insumo, Uso, Consumo) por nota do Ecredac.
 * Porta o comportamento de ecredac-classificacao-store.js (protótipo): a classificação
 * padrão vem do NCM cadastrado na Tabela NCM (TXM-594, Fase 3 — GET .../classificacao-
 * -ecredac-ncm, carregado uma vez por tela em index.js e injetado aqui via
 * definirSugestoesPorNcm); o override manual por documento fica salvo no localStorage e tem
 * prioridade sobre o padrão do NCM, sem afetar as demais notas com o mesmo NCM.
 *
 * Estado de módulo (não React) de propósito: classificacaoDaNota/origemDaNota são chamadas
 * de dentro de um .map() em render (precisam ser síncronas) e também de exportarCsv (fora de
 * qualquer componente) — mesmo mecanismo já usado aqui pro localStorage, só que carregado uma
 * vez do backend em vez de lido a cada chamada.
 */
export const STORAGE_KEY = "pt_ecredac_classificacao";
export const NAO_CLASSIFICADO = "Não classificado";
export const CLASSIFICACOES = ["Insumo", "Uso", "Consumo", NAO_CLASSIFICADO];

function loadOverrides() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") return parsed;
    }
  } catch (e) {
    console.warn("EcredacClassificacaoStore: falha ao ler localStorage", e);
  }
  return {};
}

function saveOverrides(map) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (e) {
    console.warn("EcredacClassificacaoStore: falha ao gravar localStorage", e);
  }
}

let sugestoesPorNcm = {};

/** Chamado uma vez por carregamento da tela (ver index.js), com o mapa vindo da API. */
export function definirSugestoesPorNcm(mapa) {
  sugestoesPorNcm = mapa && typeof mapa === "object" ? mapa : {};
}

function classificacaoPorNcm(ncm) {
  return sugestoesPorNcm[ncm] || null;
}

/** Classificação efetiva da nota: override manual > classificação do NCM > "Não classificado". */
export function classificacaoDaNota(documento, ncm) {
  const overrides = loadOverrides();
  if (overrides[documento]) return overrides[documento];
  return classificacaoPorNcm(ncm) || NAO_CLASSIFICADO;
}

export function origemDaNota(documento, ncm) {
  const overrides = loadOverrides();
  if (overrides[documento]) return "manual";
  return classificacaoPorNcm(ncm) ? "ncm" : "nenhuma";
}

export function definirClassificacao(documento, classificacao) {
  const overrides = loadOverrides();
  overrides[documento] = classificacao;
  saveOverrides(overrides);
}
